module.exports = __webpack_public_path__ + "images/emoji/left_luggage.6847678ab60ea908cf74.png";